import { useEffect, useRef } from 'react';

import { useNavigate } from 'react-router-dom';

import { SplashScreen } from '@/shared/ui/components/SplashScreen';

import { useCustomAlerts } from '@/shared/lib/alert';

import { ROUTES } from '@/shared/constants';

import { useAuth, useRole } from '@/entities/user';

interface ActorAccessRedirectProps {
  /** Тип ресурса для отображения в сообщениях */
  resourceType: 'кастинг' | 'проект';
}

/**
 * Общий компонент для перенаправления актеров на нужные страницы
 * @param root0 - пропсы компонента
 * @param root0.resourceType - тип ресурса для отображения в сообщениях
 */
export const ActorAccessRedirect = ({
  resourceType
}: ActorAccessRedirectProps) => {
  const { showCustomAlert } = useCustomAlerts();
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const role = useRole();
  const hasRedirected = useRef(false);

  useEffect(() => {
    // Предотвращаем повторные редиректы
    if (hasRedirected.current) {
      return;
    }

    // не авторизован
    if (!isLoggedIn) {
      hasRedirected.current = true;
      showCustomAlert(`Чтобы просмотреть ${resourceType}, войдите как актер`, {
        severity: 'info'
      });
      navigate(ROUTES.auth.sign_in, { replace: true });
      return;
    }

    // авторизован, но не актер
    if (role !== 'actor') {
      hasRedirected.current = true;
      showCustomAlert(`Доступ к ${resourceType}у разрешен только актерам`, {
        severity: 'error'
      });
      navigate(ROUTES.root, { replace: true });
      return;
    }
  }, [isLoggedIn, role, resourceType]);

  // пока идёт редирект — показываем сплэш
  return <SplashScreen />;
};
